<mat-dialog-content class="coverages">
  <button
    mat-dialog-close
    class="o-modal-dismiss"
  >
    <epi-icon
      use="close"
      size="24"
    ></epi-icon>
  </button>
  <epi-heading
    level="2"
    appears-as="1"
    color="primary"
    class="coverages__heading"
  >
    What does your
    {{
    (data === accidentOnly && 'accident-only') ||
    (data === accidentIllness && 'Accident & Illness')
    }}
    plan cover?
  </epi-heading>
  <p class="coverages__subheading">
    There are no networks. You can use any licensed veterinarian.
  </p>
  <ng-container [ngSwitch]="data">
    <ng-container *ngSwitchCase="accidentIllness">
      <ng-container *ngTemplateOutlet="accidentIllnessContent"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="accidentOnly">
      <ng-container *ngTemplateOutlet="accidentOnlyContent"></ng-container>
    </ng-container>
  </ng-container>
</mat-dialog-content>

<!-- ACCIDENT ILLNESS MODAL CONTENT -->
<ng-template #accidentIllnessContent>
  <section class="coverages__coverage">
    <p class="coverages__coverage-heading coverages__coverage-heading-one">
      Embrace's accident and illness coverage includes, but is not limited to:
    </p>
    <epi-list
      marker-type="bullet"
      marker-color="secondary"
      class="coverages__coverage-list"
    >
      <li>
        <div>Cancer treatment including chemotherapy</div>
      </li>
      <li>
        <div>Chronic conditions (such as allergies</div>)
      </li>
      <li>
        <div>Congenital conditions</div>
      </li>
      <li>
        <div>Dental trauma</div>
      </li>
      <li>
        <div>Exam fees</div>
      </li>
      <li>
        <div>
          Genetic conditions (such as hip dysplasia)
        </div>
      </li>
      <li>
        <div>Prescription drug coverage</div>
      </li>
    </epi-list>
    <p class="coverages__coverage-heading coverages__coverage-heading-two">Procedures we cover include:</p>
    <epi-list
      marker-type="bullet"
      marker-color="secondary"
      class="coverages__coverage-list"
    >
      <li>
        <div>Allergy Testing</div>
      </li>
      <li>
        <div>Complementary Treatments (such as acupuncture)*</div>
      </li>
      <li>
        <div>CT scans, MRIs, X-rays, & ultrasounds</div>
      </li>
      <li>
        <div>General, specialist, & emergency care</div>
      </li>
      <li>
        <div>Hospitalization & surgery</div>
      </li>
      <li>
        <div>Lab tests & biopsies</div>
      </li>
      <li>
        <div>Physical therapy (such as hydrotherapy)</div>
      </li>
    </epi-list>
  </section>
  <section class="coverages__exclusions">
    <section class="coverages__exclusions-group">
      <p class="coverages__coverage-heading">
        Pre-existing Condition Exclusions
      </p>
      <p class="u-margin-top-small">
        A pre-existing condition is any injury, illness, or irregularity noticed
        by you or your veterinarian before the end of your waiting period, even
        if your pet never went to see a veterinarian for it.
      </p>
      <p class="u-margin-top-small">
        Unfortunately no pet insurance company covers pre-existing conditions.
        However, Embrace differentiates between curable and incurable
        conditions. If your pet remains symptom and treatment-free of a curable
        condition for 12 consecutive months, we'll reevaluate coverage.
      </p>
      <p class="u-margin-top-small">
        For full coverage details,
        <a
          qeBaseLink
          href="https://assets.ctfassets.net/cy68knbg9g5b/3VBxIBze9LzEw99K41FZ9I/402bb6b23ee79190d3291b41565aee3d/PET00_01-23_1.pdf"
          target="_blank"
          class="n--minimal"
        >
          view our policy</a>
        .
      </p>
    </section>

    <section class="coverages__exclusions-group">
      <section class="coverages__exclusions-group m--card">
        <p class="coverages__coverage-heading m--color-primary">
          Concerned about pre-existing conditions?
        </p>
        <p class="u-margin-top-small">
          Request a free
          <strong>medical history review</strong>
          after your policy purchase. If you don’t like what we find, you can
          cancel your policy and receive a pro-rated refund of the unused
          premium.
        </p>
      </section>
      <p class="u-margin-top-small">
        *Complementary treatments were previously called alternative therapies.
      </p>
    </section>
  </section>
</ng-template>
<!-- END ACCIDENT ILLNESS MODAL CONTENT -->

<!-- ACCIDENT ONLY MODAL CONTENT -->
<ng-template #accidentOnlyContent>
  <section class="coverages__coverage">
    <div
      role="presentation"
      class="coverages__coverage-group"
    >
      <p class="coverages__coverage-heading">
        Embrace's accident-only coverage includes, but is not limited to:
      </p>
      <epi-list
        marker-type="bullet"
        marker-color="secondary"
        class="coverages__coverage-list"
      >
        <li>Bloat</li>
        <li>Broken bones</li>
        <li>Animal bites</li>
        <li>Cuts & lacerations</li>
        <li>Fractured teeth</li>
        <li>Foreign body ingestion</li>
        <li>Poisoning</li>
      </epi-list>
    </div>
    <div
      role="presentation"
      class="coverages__coverage-group"
    >
      <p class="coverages__coverage-heading">
        Accident-related procedures for covered conditions, including:
      </p>
      <epi-list
        marker-type="bullet"
        marker-color="secondary"
        class="coverages__coverage-list"
      >
        <li>Exam & consultation fees</li>
        <li>
          Complementary treatments (such as acupuncture)
        </li>
        <li>CT scans, MRIs, X-rays, & unltrasounds</li>
        <li>General, specialist, & emergency care</li>
        <li>Hospitalization & surgery</li>
        <li>Diagnostic testing</li>
      </epi-list>
    </div>
  </section>
  <section class="coverages__exclusions">
    <section class="coverages__exclusions-group">
      <p class="coverages__coverage-heading">
        Exclusions
      </p>
      <p class="coverages__exclusions-subheading u-margin-block-small">
        Along with pre-existing conditions, the accident-only plan does not
        cover:
      </p>
      <epi-list
        marker-type="bullet"
        marker-color="secondary"
        class="coverages__coverage-list"
      >
        <li>Routine care</li>
        <li>Illnesses</li>
        <li>Orthopedic conditions</li>
        <li>Breed-specific & genetic conditions</li>
        <li>Congenital conditions</li>
        <li>Cancer</li>
        <li>Dental illness</li>
      </epi-list>
      <p class="coverages__exclusions-additional">
        For full coverage and exclusions, review our policy
        <a
          qeBaseLink
          class="n--minimal"
          href="{{ (isModelLawState$ | async)
            ? 'https://assets.ctfassets.net/nx3pzsky0bc9/54c01RtUrnphh8ZyFYcC5f/48187a9f21ac1e635ab6edbd93f34edb/PAC00-202402_-_WLPA.pdf' 
            : 'https://assets.ctfassets.net/nx3pzsky0bc9/7lhWmOZmYc5zxBNZ3hhzv0/706e453224c35240eb1edcc6abb58493/PAC00-201905-_Accident_Only.pdf' 
          }}"
          target="_blank"
          aria-label="Link to open Embrace Policy Terms and Conditions (New Window)"
        >
          Terms & Conditions
        </a>
      </p>
    </section>
    <section class="coverages__exclusions-group m--highlight">
      <p class="coverages__coverage-heading">
        Which pet owners should consider the Accident-only plan?
      </p>
      <epi-list
        marker-type="bullet"
        marker-color="secondary"
        class="coverages__coverage-list"
      >
        <li>
          Dogs and cats aged 15 years or older &mdash; these pets are not
          eligible for full accident and illness coverage
        </li>
        <li>
          Pets who have been diagnosed with or who have shown symptoms of
          diabetes, Cushing's disease, Addison's disease, FIV, or FELV.
        </li>
      </epi-list>
    </section>
  </section>
</ng-template>
<!-- END ACCIDENT ONLY MODAL CONTENT -->